// config.js
// const axiosurl = 'http://127.0.0.1:3001';
const axiosurl = 'https://www.openaimj.com/userapi'

export default axiosurl;